import React, { createContext, useContext, useState, useEffect } from 'react';
import { LiteratureFilter } from '../types';

interface FilterContextType {
    lit_filter: LiteratureFilter;
    setLitFilter: (filter: LiteratureFilter) => void;
    resetFilters: () => void;
}

export const FilterContext = createContext<FilterContextType | undefined>(undefined);

export function FilterProvider({ children }: { children: React.ReactNode }) {
    const [lit_filter, setLitFilter] = useState<LiteratureFilter>(() => {
        const saved = localStorage.getItem('lit_filter');
        return saved && saved !== 'undefined'
            ? JSON.parse(saved)
            : {
                  project_id: null,
                  page: 1,
                  per_page: 10,
                  review_status: null,
                  paper_status: null,
                  search: null,
                  category_filters: null,
                  reviewer_filters: null,
                  review_type: null,
                  view_mode: 'all',
                  journal: null,
                  publisher: null,
              };
    });

    useEffect(() => {
        localStorage.setItem('lit_filter', JSON.stringify(lit_filter));
    }, [lit_filter]);

    const resetFilters = () => {
        setLitFilter({
            project_id: lit_filter.project_id,
            page: 1,
            per_page: 10,
            review_status: null,
            paper_status: null,
            search: null,
            category_filters: null,
            reviewer_filters: null,
            reviewer_decision_filters: null,
            review_type: null,
            view_mode: 'all',
            journal: null,
            publisher: null,
        });
    };

    return (
        <FilterContext.Provider
            value={{
                lit_filter,
                setLitFilter,
                resetFilters,
            }}>
            {children}
        </FilterContext.Provider>
    );
}

export const useFilters = () => {
    const context = useContext(FilterContext);
    if (context === undefined) {
        throw new Error('useFilters must be used within a FilterProvider');
    }
    return context;
};
